import { Card } from "./ui/card";
import { ArrowDownRight, Coffee, Store, Utensils } from "lucide-react";

const tx = [
  { id: 1, icon: <Coffee className="text-yellow-500" size={18} />, merchant: "Starbucks", detail: "Latte", amount: "-$4.35", date: "Jul 25" },
  { id: 2, icon: <Store className="text-green-600" size={18} />, merchant: "Whole Foods", detail: "Groceries", amount: "-$53.19", date: "Jul 24" },
  { id: 3, icon: <Utensils className="text-red-500" size={18} />, merchant: "Pizza Hut", detail: "Dinner", amount: "-$20.50", date: "Jul 21" },
  { id: 4, icon: <ArrowDownRight className="text-blue-500" size={18} />, merchant: "Payroll", detail: "Salary", amount: "+$2,200.00", date: "Jul 20" }
];

const RecentTransactions = () => (
  <Card className="mt-8 px-0 pb-2 pt-4 rounded-2xl bg-background/90 shadow">
    <h2 className="font-semibold text-lg px-6 mb-2 text-primary">Recent Transactions</h2>
    <ul>
      {tx.map(t => (
        <li key={t.id} className="flex items-center px-6 py-3 border-b last:border-b-0 gap-4 w-full">
          <span>{t.icon}</span>
          <div className="flex-1">
            <div className="font-medium text-sm leading-tight">{t.merchant}</div>
            <div className="text-xs text-muted-foreground">{t.detail} • {t.date}</div>
          </div>
          <span className={t.amount.startsWith("-") ? "text-destructive font-medium" : "text-green-600 font-medium"}>{t.amount}</span>
        </li>
      ))}
    </ul>
  </Card>
);

export default RecentTransactions;
